import { render, staticRenderFns } from "./ArticleById.vue?vue&type=template&id=b41edef6&"
import script from "./ArticleById.vue?vue&type=script&lang=js&"
export * from "./ArticleById.vue?vue&type=script&lang=js&"
import style0 from "./ArticleById.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports